import React from 'react'
import { Col } from 'react-bootstrap'

const IconField = ({
    children,
    style = {},
    sm = 6
}) => {
    return (
        <Col xs={12} sm={sm} style={{ ...style, paddingTop: '10px' }}>
            {children}
        </Col>
    )
}

export default IconField